import React from 'react';
import { useTranslate } from 'react-admin';
import { FirebasePushButton } from '../../misc/FirebasePushButton';

/**
 * Event Form Header Component
 * Displays form header with event type information
 */
export const EventFormHeader = ({
  eventType,
  dateType,
  eventName,
  isEdit = false,
  isCloned = false,
  record = null,
}) => {
  const translate = useTranslate();

  const eventTypeName = translate(`create_wizard.type_${eventType}_title`, {
    _: eventType === 3 ? 'Seated Event' : eventType === 2 ? 'Area Layout Event' : 'Standard Event',
  });
  const dateTypeName = translate(
    dateType === 'session' ? 'create_wizard.session_title' : 'create_wizard.oneoff_title',
    {
      _: dateType === 'session' ? 'Multiple Dates / Sessions' : 'Single Date / One Off',
    },
  );
  const name = eventName || translate('create_wizard.clone_name_fallback', { _: 'New event' });

  const title = isEdit
    ? translate('create_wizard.header_edit', {
        name,
        type: eventTypeName,
        dateType: dateTypeName,
        _: `${name} / ${eventTypeName} (${dateTypeName})`,
      })
    : isCloned
      ? translate('create_wizard.header_clone', {
          name,
          type: eventTypeName,
          dateType: dateTypeName,
          _: `Clone: ${name} / ${eventTypeName} (${dateTypeName})`,
        })
      : translate('create_wizard.header_new', {
          type: eventTypeName,
          dateType: dateTypeName,
          _: `New ${eventTypeName} (${dateTypeName})`,
        });

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        maxHeight: 48,
        marginBottom: 20,
        flexWrap: 'wrap',
        gap: 8,
      }}
    >
      <h2 style={{ marginLeft: 15, marginRight: 8 }}>{title}</h2>
      {isEdit && record?.id ? <FirebasePushButton mode="event" record={record} /> : null}
    </div>
  );
};
